import "core-js/modules/es6.number.constructor";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CarInsuranceDrawer from "./modules/CarInsuranceDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@api/manage';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
export default {
  name: 'CarInsuranceList',
  mixins: [JeecgListMixin],
  components: {
    CarInsuranceDrawer: CarInsuranceDrawer
  },
  data: function data() {
    var _ref;

    return _ref = {
      permissionObj: {
        add: 'car:ea_asset_car_insurance:add',
        delete: 'car:ea_asset_car_insurance:delete',
        edit: 'car:ea_asset_car_insurance:edit',
        deleteBatch: 'car:ea_asset_car_insurance:deleteBatch'
      },
      carShow: true,
      pagePath: '/asset/car/insurance',
      pageTitle: '车辆保险',
      carList: [],
      companyList: [],
      autoLoadInit: false,
      userTree: [],
      //人员信息
      url: {
        queryCar: '/asset/car/queryCarCards',
        queryCompany: '/ea/company/info/queryCompanyName'
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'card',
        colName: 'car_id',
        title: '车牌号',
        align: 'center'
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '登记人',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'name',
        colName: 'company_id',
        title: '保险公司',
        align: 'center'
      }, {
        dataIndex: 'insureDate',
        colName: 'insure_date',
        title: '投保时间',
        align: 'center'
      }, {
        dataIndex: 'sdate',
        colName: 'sdate',
        title: '保险起始时间',
        align: 'center'
      }, {
        dataIndex: 'edate',
        colName: 'edate',
        title: '保险结束时间',
        align: 'center'
      }, {
        dataIndex: 'total',
        colName: 'total',
        title: '总金额',
        align: 'center'
      }, // {
      //   dataIndex: 'fileId',
      //   colName: 'file_id',
      //   title: '附件',
      //   align: 'center'
      // },
      // {
      //   dataIndex: 'remark',
      //   colName: 'remark',
      //   title: '备注',
      //   align: 'center',
      //   sorter: true
      // },
      {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '保险状态',
        align: 'center',
        sorter: true
      }, // {
      //   dataIndex: 'sort',
      //   colName: 'sort',
      //   title: '排序号',
      //   align: 'center',
      //   sorter: true
      // },
      {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    }, _defineProperty(_ref, "url", {
      carList: '/ea/asset/car/queryCarCards'
    }), _defineProperty(_ref, "siteName", ''), _ref;
  },
  props: {
    carId: {
      type: Number,
      default: null
    },
    carDetails: Boolean
  },
  created: function created() {
    this.queryUserTreeList(); // this.loadCar()//车辆
    // this.loadCompany()//厂商

    if (this.carDetails) {
      this.queryParam.carId = this.carId;
      this.carShow = !this.carDetails;
    }

    this.loadData();
    this.queryCarList();
  },
  watch: {
    currentSiteName: function currentSiteName(newVal, oldVal) {
      this.siteName = newVal;
    },
    currentSiteId: function currentSiteId(newVal) {
      this.siteId = newVal;
    }
  },
  computed: {},
  methods: {
    /**
     * 时间筛选
     * @param value
     * @param insureDate
     */
    onDateSdata: function onDateSdata(value, insureDate) {
      this.queryParam.insureDateTime = insureDate;
    },
    loadCar: function loadCar() {
      var that = this;
      that.carList = [];
      getAction(this.url.queryCar).then(function (res) {
        if (res.success) {
          that.carList = res.result;
        }
      });
    },
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    //车牌信息列表
    queryCarList: function queryCarList() {
      var that = this;
      that.carList = [];
      getAction(that.url.carList).then(function (res) {
        if (res.success) {
          that.carList = res.result;
        }
      });
    },
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    searchReset: function searchReset() {
      this.queryParam = {
        carId: this.carId
      };
      this.dates = {};
      this.loadData(1);
    },
    modalFormOk: function modalFormOk() {
      this.queryParam = {
        carId: this.carId
      };
      this.loadData(1);
    },
    handleAdd: function handleAdd() {
      if (this.carId != null) {
        this.$refs.modalForm.add(this.carId);
      } else {
        this.$refs.modalForm.add();
      }

      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    handleDetail: function handleDetail(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = this.pageTitle + '详情';
      this.$refs.modalForm.disableSubmit = true;
      this.$refs.modalForm.disableStatus = true;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = false;
    },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;

      if (this.carId != null) {
        this.$refs.modalForm.disableStatus = true;
      } else {
        this.$refs.modalForm.disableStatus = false;
      }

      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};